import _get from 'lodash/get';
import { DocumentationCategory } from 'graphql-common';
import { Values } from '@lib/interfaces/form';
import FieldNames from '@lib/enums/fieldNames/documentCategoryFieldNames';

export default function getDefaultValuesFromQueryData(
  data: DocumentationCategory,
): Values {
  return {
    [FieldNames.Id]: _get(data, 'id', null),
    [FieldNames.Name]: _get(data, 'name', ''),
    [FieldNames.Color]: { value: _get(data, 'color', null) },
    [FieldNames.Description]: _get(data, 'description', ''),
  };
}
